import { forwardRef } from 'react';
import { SystemIcon } from '@monorepo/nova-icons';
import { CLICKABLE_TITLE_CONSTANTS } from './constants';
import {
  CaretWrapper,
  ClickableTitleContainer,
  ClickableTitleText,
} from './styled';
import type { ClickableTitleProps } from './types';

export const ClickableTitle = forwardRef<HTMLDivElement, ClickableTitleProps>(
  ({ title, isOpen, onClick, variant = 'h3' }, ref) => {
    return (
      <ClickableTitleContainer ref={ref} onClick={onClick}>
        <ClickableTitleText variant={variant}>{title}</ClickableTitleText>
        <CaretWrapper isOpen={isOpen}>
          <SystemIcon
            iconName="CaretRight"
            size={CLICKABLE_TITLE_CONSTANTS.CARET_SIZE}
          />
        </CaretWrapper>
      </ClickableTitleContainer>
    );
  },
);

ClickableTitle.displayName = 'ClickableTitle';
